import {identity} from "lodash";
import {SocialNetwork} from "data/enums";
import {FACEBOOK_ID} from "data/constants";

interface IGeneralShare {
	socialNetwork: SocialNetwork;
	title?: string;
	message?: string;
	link: string;
	files?: File[];
}

type IShare = IGeneralShare;

const shareFB = ({link, ...data}: IShare) => {
	if (!FACEBOOK_ID) {
		const winWidth = 626;
		const winHeight = 436;
		const winTop = window.screen.height / 2 - winHeight / 2;
		const winLeft = window.screen.width / 2 - winWidth / 2;

		window.open(
			`https://www.facebook.com/sharer/sharer.php?display=popup&u=${link}`,
			"_blank",
			`top=${winTop},left=${winLeft},width=${winWidth}, height=${winHeight},toolbar=0,status=0,scrollbars=no,resizable=1`
		);
		return;
	}

	window?.FB?.ui(
		{
			method: "share",
			display: "popup",
			href: link,
		},
		identity
	);
};

const shareTW = ({message = "", link, ...params}: IShare) =>
	window.open(
		"https://twitter.com/intent/tweet?url=" +
			encodeURIComponent(link) +
			"&text=" +
			encodeURIComponent(message),
		"twitter-share-dialog",
		"width=626,height=436"
	);

const shareMobile = ({message = "", link, title, ...params}: IShare) => {
	void navigator
		.share({
			url: link,
			...params,
			title,
			text: message,
		})
		.catch((_err) => {
			// Do nothing
		});
};

const callbacks = {
	[SocialNetwork.Twitter]: shareTW,
	[SocialNetwork.Facebook]: shareFB,
	[SocialNetwork.Mobile]: shareMobile,
} as const;

export const share = (data: IShare) => callbacks[data.socialNetwork](data);
